module.exports = __webpack_public_path__ + "static/media/logo-youtube.64f245dd.svg";